module.exports = "<div tabindex=\"-1\">\r\n    <gw-typeahead-match-content index=\"index\" match=\"match\" query=\"query\" directive=\"selectDirective()\"></gw-typeahead-match-content>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./common/grunt/webpack/loaders/text-loader!./common/js/src/edge/platform/widgets/typeahead/templates/typeahead-match.html
// module id = 612
// module chunks = 0